var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Example of an inline "),_c('code',[_vm._v("<code>")]),_vm._v(" element. ")])
}]

export { render, staticRenderFns }